import {environment} from '../../../environments/environment';

export interface DateTimeObject {
  date: string;
  timezone_type: number;
  timezone: string;
}

export interface InfoLink {
  id: number;
  category_es: string;
  category_en: string;
  category_de: string;
  category_fr: string;
  category_it: string;
  name_es: string;
  name_en: string;
  name_de: string;
  name_fr: string;
  name_it: string;
  phone: string;
  address: string | null;
  latitude: string | null;
  longitude: string | null;
  image: string | null;
  created_at: DateTimeObject | null;
  updated_at: DateTimeObject | null;
}

export type InfoLinks = InfoLink[];

function getInfoLinkCategoryByLanguage(infoLink: InfoLink, lang: string): string {
  return infoLink[`category_${lang}` as keyof InfoLink] as string || infoLink.category_es;
}

function getInfoLinkNameByLanguage(infoLink: InfoLink, lang: string): string {
  return infoLink[`name_${lang}` as keyof InfoLink] as string || infoLink.name_es;
}

export function getInfoLinkCategory(infoLink: InfoLink): string {
  return getInfoLinkCategoryByLanguage(infoLink, environment.defaultAppLang);
}

export function getInfoLinkName(infoLink: InfoLink): string {
  return getInfoLinkNameByLanguage(infoLink, environment.defaultAppLang);
}
